import { FindMessagesFromRemoteResponse } from '@/services/AiService.interface';
import { request } from '@umijs/max';
import BASEURLCONFIG from '../../config/BASEURLCONFIG';

export async function findConversations(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/conversations', {
    params,
  });
}

export async function stopResponse(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/chat-messages/' + params.taskId + '/stop',
    {
      method: 'POST',
      data: params,
    },
  );
}

export async function findMessagesFromRemote(params: any): Promise<FindMessagesFromRemoteResponse> {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/messages', {
    params,
  });
}

export async function conversationsRename(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/conversations/' + params.conversationId + '/name',
    {
      method: 'POST',
      data: params,
    },
  );
}

export async function conversationsForDelete(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/conversations/' + params.conversationId, {
    method: 'DELETE',
    params,
  });
}

export async function findDocuments(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/datasets/' + params.dataset_id + '/documents',
    {
      params,
    },
  );
}

export async function findSegments(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL +
      '/api/ai/v1/datasets/' +
      params.dataset_id +
      '/documents/' +
      params.document_id +
      '/segments',
    {
      params,
    },
  );
}

export async function getDocumentTextById(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL +
      '/api/ai/v1/datasets/' +
      params.dataset_id +
      '/documents/' +
      params.document_id +
      '/segments',
    {
      params,
    },
  );
}

export async function createArticleByText(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL +
      '/api/ai/v1/datasets/' +
      params.dataset_id +
      '/document/create-by-text',
    {
      method: 'POST',
      data: params,
    },
  );
}

export async function updateArticleByText(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL +
      '/api/ai/v1/datasets/' +
      params.dataset_id +
      '/documents/' +
      params.document_id +
      '/update-by-text',
    {
      method: 'POST',
      data: params,
    },
  );
}

export async function deleteDocument(params: any) {
  return request(
    BASEURLCONFIG.ISWAN_AI_URL +
      '/api/ai/v1/datasets/' +
      params.dataset_id +
      '/documents/' +
      params.document_id,
    {
      method: 'DELETE',
      params,
    },
  );
}

export async function setMarkdownContentToCache(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/office/setMarkdownContentToCache', {
    method: 'POST',
    data: params,
  });
}

export async function createNewKnowledge(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/datasets', {
    method: 'POST',
    data: params,
  });
}

export async function getHasDataset(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/knowledge/hasDataset', {
    method: 'GET',
    params,
  });
}

export async function getParameters(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/parameters', {
    method: 'GET',
    params,
  });
}

export async function getSite(params: any) {
  return request(BASEURLCONFIG.ISWAN_AI_URL + '/api/ai/v1/site', {
    method: 'GET',
    params,
  });
}


